import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { RecommendationStrategy } from 'lumen/models';
import type { RecommendationsModel } from 'lumen/routes/hotel/settings/recommendations';

export default class HotelSettingsRecommendationsRoomHierarchyRoute extends Route {
  @service declare access: Services['access'];
  @service declare router: Services['router'];
  @service declare usageAnalytics: Services['usage-analytics'];

  saveStrategyTask = task(
    { drop: true },
    async (strategyRecord: RecommendationStrategy) => {
      const parentModel = this.modelFor(
        'hotel.settings.recommendations',
      ) as RecommendationsModel;

      this.usageAnalytics.track('Room Hierarchy Saved', {
        eventTrigger: 'recommendation-settings',
        product: 'pricing-manager',
      });

      return parentModel.saveStrategyTask.perform(strategyRecord);
    },
  );

  beforeModel(): void {
    const isHotelWithMultipleRoomTypes =
      this.access.hasPricingAssistantOpenPricingFeature ||
      this.access.hasPricingAssistantDynamicRatePricingFeature;

    if (!isHotelWithMultipleRoomTypes) {
      this.router.transitionTo('hotel.settings.recommendations');
    }
  }

  model(): RecommendationsModel {
    return {
      ...(this.modelFor(
        'hotel.settings.recommendations',
      ) as RecommendationsModel),
      saveStrategyTask: this.saveStrategyTask,
    };
  }
}
